import React, { useState } from 'react'
import biographyStyle from './biographyInfo.module.css'
require('typeface-poppins')


export default function BiographyInfo({ bio }) {

    const [openIndex, setOpenIndex] = useState(null); // state to track open accordion item, null means none are open

    const handleToggle = (index) => {
        // Toggle between opening and closing the same accordion item
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <div className={`${biographyStyle.contactAccordion} accordion mb-3`} id="ContactInfo">
                <div className={`${biographyStyle.contactMainitem} accordion-item`}>
                    <h2 className="accordion-header">
                        <button className={`${biographyStyle.contactbuttonItem} ${biographyStyle.biographyBeforebg} accordion-button ${openIndex === 0 ? '' : `${biographyStyle.biographybgColor} collapsed`}`} type="button" onClick={() => handleToggle(0)} aria-expanded={openIndex === 0 ? 'true' : 'false'} aria-controls="collapseOne">
                            Biography
                        </button>
                    </h2>
                    <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === 0 ? 'show' : ''}`} data-bs-parent="#ContactInfo">
                        <div className={`${biographyStyle.moreBody} accordion-body`}>
                            <div className={biographyStyle.infoWrapper}>
                                <p> {bio} </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}